import Button from 'components/Button'
import Control from 'components/Control/Control'
import Flex from 'components/Flex'
import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import RejectedIcon from '../../../../assets/icons/RejectedIcon'
import SuccessIcon from '../../../../assets/icons/SuccessIcon'
import {
  Container,
  Content,
  Description,
  FlexWrapRole,
  Spacer,
  TopHeading,
} from '../../Style/style'

const ResultScreen = () => {
  const params = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const selected = queryParams.get('selected')

  const FinalNavigation = () => {
    navigate(
      `/roles/viewRole/${params.CorpID}/${params.JobID}/questionnaire/feedback`
    )
  }

  //to block back button
  history.pushState(null, null, location.href)
  window.onpopstate = function () {
    history.go(1)
  }
  return (
    <Container alignCenter column center>
      <Content spaceBetween center column>
        {!selected ? (
          <Flex column alignCenter>
            <FlexWrapRole center>
              <SuccessIcon />
            </FlexWrapRole>
            <TopHeading center alignCenter>
              You Applied Successfully !
            </TopHeading>
          </Flex>
        ) : (
          <Flex column alignCenter>
            <FlexWrapRole center>
              <RejectedIcon />
            </FlexWrapRole>
            <Spacer />
            <TopHeading center alignCenter>
              Your application has been rejected because your answers did not
              align with the qualifying questions.
            </TopHeading>
            <Description center mt={'6px'}>
              We appreciate your interest and wish you the best in your job
              search.
            </Description>
          </Flex>
        )}
        <Control width="100%" center top="20px">
          <Button.Primary text="Done" onClick={FinalNavigation} />
        </Control>
      </Content>
    </Container>
  )
}

export default ResultScreen
